/**
 * Uniwersalny model powiadomienia (Push Notification) wewnątrz aplikacji.
 * Służy do normalizacji danych przychodzących z serwisu OneSignal oraz przechowywania historii powiadomień.
 * Zawiera logikę nawigacyjną (`gotoPath`), która pozwala na przekierowanie użytkownika
 * do konkretnego widoku (Deep Link).
 */
export class GenericNotification {

  /** Unikalny identyfikator powiadomienia. */
  public id: string;

  /**
   * Ścieżka nawigacyjna w formie stringa (np. "visits/details/123").
   * Określa, gdzie aplikacja ma przenieść użytkownika po interakcji z powiadomieniem.
   */
  public gotoPath: string;

  /** Nagłówek powiadomienia. */
  public title: string;

  /**
   * Status przeczytania.
   * - `true`: Powiadomienie wyświetlone/kliknięte.
   * - `false`: Nowe powiadomienie.
   */
  public wasSeen: boolean;

  /** Główna treść wiadomości. */
  public content: string;

  /** Data otrzymania powiadomienia. */
  public date: Date;

  /**
   * Metoda pomocnicza parsująca ścieżkę `gotoPath` na format routera Angulara.
   * Dzieli string po znakach `/` na tablicę segmentów.
   *
   * Przykład: "my-pets/edit/55" -> ["my-pets", "edit", "55"]
   *
   * @returns Tablica segmentów ścieżki gotowa do użycia w `router.navigate()`.
   */
  public getGotoCommands(): string[] {
    const gotoCmds = this.gotoPath?.split('/');
    if (gotoCmds && gotoCmds.length > 0) {
      return gotoCmds;
    }
  }

  constructor() {
  }
}
